var map = {
	"./boy.svg": "b730",
	"./clock.svg": "fe0e",
	"./comment.svg": "03e4",
	"./drop-off-rates.svg": "62f8",
	"./financial-stability.svg": "80be",
	"./financial1.svg": "ffd5",
	"./girl.svg": "efc2",
	"./improved-intervention.svg": "9d40",
	"./linked-in-color.svg": "681f",
	"./menu_icon.svg": "62c6",
	"./revenue-capture.svg": "9045",
	"./segmentation.svg": "4816",
	"./solutions_1.svg": "334b",
	"./solutions_2.svg": "5a06",
	"./transparency.svg": "fac8",
	"./treatment1.svg": "92bd",
	"./work-flow.svg": "325d",
	"./zero-fees.svg": "bb07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2739";